// Check Referral Code's vailidity - Normal Referral Invite
export const SEND_SYSTEM_NOTIFICATION_EMAIL_REQUEST = 'send_system_notification_email_request';
export const SEND_SYSTEM_NOTIFICATION_EMAIL_SUCCESS = 'send_system_notification_email_success';
export const SEND_SYSTEM_NOTIFICATION_EMAIL_FAILURE = 'send_system_notification_email_failure';

export const UNLOCK_ROOM_REQUEST = 'unlock_room_request';
export const UNLOCK_ROOM_SUCCESS = 'unlock_room_success';
export const UNLOCK_ROOM_FAILURE = 'unlock_room_failure';

export const SET_IS_MOBILE_VIEW = 'set_is_mobile_view';
export const SET_IS_SHRUNK_HEADER = 'set_is_shrunk_header';
export const SET_IS_LOCKED_ROOM = 'set_is_locked_room';
export const SET_LOCKED_ROOM_LIVE_METADATA = 'set_locked_room_live_metadata';

export const SET_DEEP_MODAL_TRANSFER_PAYLOAD = 'set_deep_modal_transfer_payload'
export const RESET_DEEP_MODAL_TRANSFER_PAYLOAD = 'reset_deep_modal_transfer_payload'
// TODO:  Have a new action types file to manage room locking functions